<template>
    <NestedTableCard
        :active-fields="columns"
        :fields="columns"
        :name-column="nameColumn"
        :fetch="fetch"
        @click="edit"
    >
        <template #header-label>
            {{ $t('Page(SystemServices):Component(Text):services') }}
        </template>

        <template #header-controls>
            <Button v-if="$can('visit', 'system-services-create')" @click="$router.push({name: 'system-services-create'})" class="btn-icon">
                <feather-icon icon="PlusIcon" />
            </Button>
        </template>

        <template #cell-applications="data">
            <b-badge v-for="app in data.item.applications" class="mr-50" variant="primary">{{ app }}</b-badge>
        </template>

        <template #cell-operations="data">
            <b-badge v-for="operation in data.item.operations" style="margin-right: 4px">{{ operation }}</b-badge>
        </template>
    </NestedTableCard>
</template>

<script>
import {
    BForm, BFormTextarea, BCard, BModal, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import {Button} from "@core/components/common";
import {SystemApi} from '@core/api'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import NestedTableCard from "@core/components/common/NestedTableCard";

export default {
    components: {
        ToastificationContent, NestedTableCard, Button,
        BFormTextarea,
        BModal,
        BForm,
        BCard,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
    },
    directives: {
        Ripple,
    },
    name: "SystemServices",
    data() {
        return {
            nameColumn: {
                key: 'name',
                label: this.$t('Component(Grid):column-name')
            },
            pageLength: 'All',
            direction: false,
            operations: [],
            columns: [
                {
                    key: 'title',
                    label: this.$t('Page(SystemServices):Component(Text):title'),
                },
                {
                    key: 'applications',
                    label: this.$t('Component(Grid):column-applications')
                },
                {
                    key: 'description',
                    label: this.$t('Page(SystemServices):Component(Text):description'),
                },
                // {
                //     key: 'operations',
                //     label: this.$t('Page(SystemServices):Component(Text):operations'),
                // },
            ],
            translations: [],
            selectedKey: '',
            rows: [],
            searchTerm: '',
        }
    },
    methods: {

        edit(service) {
            if (this.$can('visit', 'system-services-card')) {
                this.$router.push({
                    name: 'system-services-card',
                    params: {id: service.id}
                })
            }
        },

        fetch(config, cb) {
            SystemApi.services.getGrid().then((r) => {
                cb(r.data.length, r.data);
            })
        }
    },
    computed: {
        language() {
            return this.$store.getters.language;
        }
    },
    watch: {
        language() {
            // refetch
        }
    },
}
</script>
